import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";
import { api, apiErrorMessage, formatDate } from "@/lib/api";

export default function AdminComments() {
  const [status, setStatus] = useState("pending");
  const [comments, setComments] = useState([]);

  const load = () => api.get("/comments/admin/all", { params: { status } }).then(({ data }) => setComments(data));
  useEffect(() => { load(); }, [status]);

  const moderate = async (id, newStatus) => {
    try {
      await api.patch(`/comments/admin/${id}`, { status: newStatus });
      load();
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Изтриване на коментара?")) return;
    await api.delete(`/comments/admin/${id}`);
    load();
  };

  return (
    <div data-testid="admin-comments-page">
      <h1 className="font-serif text-3xl font-bold text-[#1A1A1A] mb-6">Модерация на коментари</h1>
      <Tabs value={status} onValueChange={setStatus} className="mb-6">
        <TabsList>
          <TabsTrigger value="pending" data-testid="admin-comments-tab-pending">Чакащи</TabsTrigger>
          <TabsTrigger value="approved" data-testid="admin-comments-tab-approved">Одобрени</TabsTrigger>
          <TabsTrigger value="rejected" data-testid="admin-comments-tab-rejected">Отхвърлени</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="bg-white border border-[#E2E8F0] divide-y divide-[#E2E8F0]">
        {comments.map((c) => (
          <div key={c.id} className="p-4 flex items-start justify-between gap-4" data-testid="admin-comment-moderation-row">
            <div>
              <div className="text-sm font-semibold text-[#1A1A1A]">{c.user_name} <span className="text-[#718096] font-normal">&middot; {formatDate(c.created_at)}</span></div>
              <p className="text-sm text-[#2D3748] mt-1">{c.content}</p>
            </div>
            <div className="flex gap-2 flex-shrink-0">
              {status !== "approved" && <Button size="sm" onClick={() => moderate(c.id, "approved")} className="bg-green-600 hover:bg-green-700">Одобри</Button>}
              {status !== "rejected" && <Button size="sm" variant="outline" onClick={() => moderate(c.id, "rejected")}>Отхвърли</Button>}
              <Button size="sm" variant="outline" onClick={() => remove(c.id)} className="text-red-600 border-red-200">Изтрий</Button>
            </div>
          </div>
        ))}
        {comments.length === 0 && <p className="p-4 text-sm text-[#718096]">Няма коментари в тази категория.</p>}
      </div>
    </div>
  );
}
